import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';

import Label from '../Label/Label';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';

import styles from './PermissionSwitch.module.css';

const PermissionPageField = ({ field, changed, children }) => {
    if (!field) {
        // Incase of not visible field by system mode.
        return null;
    }
    const fieldChildren = !children || Array.isArray(children) ? children : [children];

    const classes = makeStyles({
        root: {
            borderRadius: '20px',
            textTransform: 'none',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.7)',
            width: '60px'
        }
    })();

    return (
        <div className={styles.sectionContainer}>
            <div className={styles.fieldsContainer}>
                <div className={styles.titleContainer}>
                    <Label value={field.name} bold={false} />
                    {field.desc && <span>{`(${field.desc})`}</span>}
                </div>
                <div className={styles.buttonsContainer}>
                    <ToggleButtonGroup
                        className={styles.buttonGroup}
                        value={field.value}
                        exclusive
                        onChange={(e, newVal) => changed(field.id, newVal)}
                        aria-label="text alignment">
                        <ToggleButton value={ROLES.NONE.value} classes={{ root: classes.root }}>
                            {ROLES.NONE.label}
                        </ToggleButton>

                        <ToggleButton value={ROLES.VIEWER.value} classes={{ root: classes.root }}>
                            {ROLES.VIEWER.label}
                        </ToggleButton>
                        <ToggleButton value={ROLES.EDITOR.value} classes={{ root: classes.root }}>
                            {ROLES.EDITOR.label}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>
            {fieldChildren && (
                <span className={styles.children}>
                    {fieldChildren.map((child, index) => {
                        return (
                            child && (
                                <span key={`child_${index}`} className={styles.childContainer}>
                                    <i className={`${styles.childBullet} fa fa-square`} aria-hidden="true"></i>
                                    {child}
                                </span>
                            )
                        );
                    })}
                </span>
            )}
        </div>
    );
};

export default React.memo(PermissionPageField);
